export default "__VITE_ASSET__CPwxUReK__"